/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
window.okeReviewsWidgetOnInit = function (okeInitApi) {
  if (typeof okeWidgetControlInit === 'function') {
    okeWidgetControlInit();
  }

  window.refreshOkendo = function () {
    okeInitApi.initCoreWidgets();
  };

  setupAggregate();

  const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
  if (reviewMain) {
    const callback = function (mutationList) {
      for (const mutation of mutationList) {
        mutation.addedNodes.forEach((n) => setupIndividualReviews(n));
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(reviewMain, {childList: true});

    // Run callback for the first time
    const reviews = document.querySelectorAll('.okeReviews-reviews-review');
    reviews.forEach((n) => setupIndividualReviews(n));
  }
};

function setupAggregate() {
  const controlSort = document.querySelector('.okeReviews-reviews-controls-sort');
  const writeAReview = document.querySelector('.js-okeReviews-writeReview');

  if (controlSort && writeAReview) {
    controlSort.insertAdjacentElement('afterend', writeAReview);
  }
}

function setupIndividualReviews(nodeElement) {
  formatDateForElement();
  const reviewerProfileDetails = nodeElement.querySelector('.okeReviews-review-reviewer-profile-details');
  const reviewDate = nodeElement.querySelector('.okeReviews-review-date');

  if (reviewerProfileDetails && reviewDate) {
    reviewerProfileDetails.insertAdjacentElement('beforeend', reviewDate);
  }

  const reviewHeadiing = nodeElement.querySelector('.okeReviews-review-main-heading');
  const reviewMeta = nodeElement.querySelector('.js-okeReviews-reviewMeta');

  if (reviewHeadiing && reviewMeta) {
    reviewHeadiing.insertAdjacentElement('afterend', reviewMeta);
  }

  const reviewArguments = nodeElement.querySelector('.okeReviews-review-arguments');
  const reviewAttributes = nodeElement.querySelector('.okeReviews-review-reviewer-attributes');
  const sideInner = nodeElement.querySelector('.okeReviews-review-side-inner');

  if (reviewArguments && reviewAttributes) {
    reviewArguments.insertAdjacentElement('afterbegin', reviewAttributes);
  } else {
    if (sideInner && reviewAttributes) {
      sideInner.insertAdjacentElement('beforeend', reviewAttributes);
    }
  }
}

const dateFormat = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

function formatDateForElement() {
  const reviewDates = document.querySelectorAll('[data-oke-reviews-date]');
  for (const reviewDate of reviewDates) {
    const dateIsoString = reviewDate.getAttribute('data-oke-reviews-date');
    const date = new Date(dateIsoString);
    const localeDate = `${dateFormat.format(date)}`;
    var datearray = localeDate.split('/');
    reviewDate.innerText = datearray[1] + ' / ' + datearray[0] + ' / ' + datearray[2];
  }
}
